"use client"

import { useState, useEffect } from "react"
import JobCard from "./JobCard"
import axios from 'axios'
// import "bootstrap/dist/css/bootstrap.min.css"
import { FaSearch, FaBriefcase, FaUsers, FaGraduationCap, FaHandshake, FaRocket } from "react-icons/fa"

const CareerPage = () => {
  const [activeFilter, setActiveFilter] = useState("all")
  const [searchTerm, setSearchTerm] = useState("")
  const [filteredJobs, setFilteredJobs] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [activeTab, setActiveTab] = useState("openings")
    const [careerCategories, setCareerCategories] = useState([]) // categories
  const [jobs, setJobs] = useState([]) 
  // Sample job data
  const jobsData = [
    {
      id: 1,
      title: "Frontend Developer",
      location: "Remote",
      type: "Full-time",
      category: "engineering",
      description:
        "We're looking for a talented Frontend Developer to join our team. You'll be responsible for building responsive user interfaces using React, working closely with designers and backend developers to create seamless user experiences.",
    },
    {
      id: 2,
      title: "UX/UI Designer",
      location: "New York, NY",
      type: "Full-time",
      category: "design",
      description:
        "Join our design team to create beautiful, intuitive user experiences. You should have a strong portfolio demonstrating your design thinking and experience with Figma, Sketch, and other design tools.",
    },
    {
      id: 3,
      title: "Backend Developer",
      location: "Remote",
      type: "Full-time",
      category: "engineering",
      description:
        "We need a Backend Developer to help build and maintain our server infrastructure. Experience with Node.js, Express, and database technologies is required.",
    },
    {
      id: 4,
      title: "Product Manager",
      location: "San Francisco, CA",
      type: "Full-time",
      category: "product",
      description:
        "As a Product Manager, you'll work closely with engineering, design, and marketing teams to define product strategy and roadmap. You should have experience with agile methodologies and a track record of successful product launches.",
    },
    {
      id: 5,
      title: "Marketing Specialist",
      location: "Chicago, IL",
      type: "Full-time",
      category: "marketing",
      description:
        "We're seeking a Marketing Specialist to help grow our brand presence. You'll be responsible for creating content, managing social media, and analyzing campaign performance.",
    },
    {
      id: 6,
      title: "Data Scientist",
      location: "Remote",
      type: "Contract",
      category: "data",
      description:
        "Join our data team to help extract insights from our growing dataset. Experience with Python, SQL, and machine learning frameworks is required.",
    },
  ]

   const fetchCareerCategories = async () => {
    try {
      const { data } = await axios.get("https://admin.lumetiq.in/api/get-career-category.php")
      if (data.status === "success") {
        setCareerCategories(data.data)
      }
    } catch (error) {
      console.error("Error fetching categories:", error)
    }
  }

  // Fetch jobs
  const fetchJobs = async () => {
    try {
      const { data } = await axios.get("https://admin.lumetiq.in/api/get-career.php")
      if (data.status === "success") {
        setJobs(data.data)
        setFilteredJobs(data.data) // initially show all jobs
      }
    } catch (error) {
      console.error("Error fetching jobs:", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchCareerCategories()
    fetchJobs()
  }, [])


useEffect(() => {
  let results = jobs;

  if (activeFilter !== "all") {
    results = results.filter((job) => job.category_name === activeFilter); 
  }

  if (searchTerm) {
    results = results.filter(
      (job) =>
        job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.location.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  setFilteredJobs(results);
}, [activeFilter, searchTerm, jobs]);




 
  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Senior Developer",
      image: "https://randomuser.me/api/portraits/women/32.jpg",
      quote:
        "Joining this company was the best career decision I've made. The culture is amazing, and I've grown so much professionally in just a year.",
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Product Designer",
      image: "https://randomuser.me/api/portraits/men/44.jpg",
      quote:
        "I love the autonomy and trust we're given. Leadership truly values our input, and we're encouraged to experiment and innovate.",
    },
    {
      id: 3,
      name: "Priya Patel",
      role: "Marketing Manager",
      image: "https://randomuser.me/api/portraits/women/68.jpg",
      quote:
        "The work-life balance here is real, not just talk. I feel supported both professionally and personally, which makes me more productive.",
    },
  ]

 
  const values = [
    {
      icon: <FaRocket className="display-4 mb-3" style={{ color: "#009FE1" }} />,
      title: "Innovation",
      description: "We push boundaries and embrace new ideas to create cutting-edge solutions.",
    },
    {
      icon: <FaHandshake className="display-4 mb-3" style={{ color: "#009FE1" }} />,
      title: "Collaboration",
      description: "We believe in the power of teamwork and diverse perspectives.",
    },
    {
      icon: <FaGraduationCap className="display-4 mb-3" style={{ color: "#009FE1" }} />,
      title: "Growth",
      description: "We're committed to continuous learning and development.",
    },
    {
      icon: <FaUsers className="display-4 mb-3" style={{ color: "#009FE1" }} />,
      title: "Inclusion",
      description: "We celebrate diversity and create a sense of belonging for all.",
    },
  ]

 
  const benefits = [
    {
      title: "Competitive Salary",
      description: "We offer above-market compensation packages",
      icon: "💰",
    },
    {
      title: "Remote-First Culture",
      description: "Work from anywhere in the world",
      icon: "🌎",
    },
    {
      title: "Health & Wellness",
      description: "Comprehensive health insurance and wellness programs",
      icon: "🏥",
    },
    {
      title: "Professional Development",
      description: "Budget for courses, conferences, and certifications",
      icon: "📚",
    },
    {
      title: "Work-Life Balance",
      description: "Flexible hours and unlimited PTO policy",
      icon: "⚖️",
    },
    {
      title: "Team Events",
      description: "Regular team retreats and social activities",
      icon: "🎉",
    },
  ]




  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }}>
      {/* Hero Section */}
      {/* <div
        className="position-relative"
        style={{
          backgroundImage: "url('/placeholder.svg?height=800&width=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          color: "white",
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            backgroundImage: "linear-gradient(135deg, rgba(109, 40, 217, 0.8) 0%, rgba(139, 92, 246, 0.8) 100%)",
          }}
        ></div>

        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-8">
              <h1
                className="display-2 fw-bold mb-4"
                style={{
                  textShadow: "0px 2px 4px rgba(0,0,0,0.3)",
                }}
              >
                Join Our Team of Innovators
              </h1>
              <p className="lead fs-4 mb-5">
                We're on a mission to transform the industry with innovative solutions. Come build the future with us
                and be part of something extraordinary.
              </p>
              <div className="d-flex flex-wrap gap-3">
                <a
                  href="#job-openings"
                  className="btn btn-light btn-lg px-4 py-3 fw-bold"
                  style={{
                    borderRadius: "30px",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-5px)"
                    e.target.style.boxShadow = "0 10px 20px rgba(0,0,0,0.15)"
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0)"
                    e.target.style.boxShadow = "0 4px 14px rgba(0,0,0,0.1)"
                  }}
                >
                  View Open Positions
                </a>
                <a
                  href="#about-us"
                  className="btn btn-outline-light btn-lg px-4 py-3 fw-bold"
                  style={{
                    borderRadius: "30px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-5px)"
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0)"
                  }}
                >
                  Learn About Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* About Us Section */}
      <section id="about-us" className="py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <img
                src="assets/img/about/Picture1.jpg"
                alt="Team working together"
                className="img-fluid rounded-4 shadow-lg"
                style={{
                  transform: "rotate(-2deg)",
                  border: "10px solid white",
                }}
              />
            </div>
            <div className="col-lg-6">
              <div className="ps-lg-5">
                <h6 className="text-uppercase fw-bold" style={{ color: "#009FE1", letterSpacing: "2px" }}>
                  About Us
                </h6>
                <h2 className="display-5 fw-bold mb-4">We're Building The Future</h2>
                <p className="lead mb-4">
                  We're a team of passionate individuals dedicated to creating innovative solutions that make a
                  difference. Our mission is to transform how people interact with technology.
                </p>
                <p className="mb-4">
                  Founded in 2015, we've grown from a small startup to a global company with offices around the world.
                  Our success is built on our commitment to excellence, innovation, and our amazing team members.
                </p>
                <div className="d-flex align-items-center">
                  <div className="d-flex">
                    {[1, 2, 3, 4].map((num) => (
                      <img
                        key={num}
                        src={`https://randomuser.me/api/portraits/${num % 2 === 0 ? "women" : "men"}/${num * 10}.jpg`}
                        alt={`Team member ${num}`}
                        className="rounded-circle border border-3 border-white"
                        style={{
                          width: "50px",
                          height: "50px",
                          marginLeft: num === 1 ? "0" : "-15px",
                          objectFit: "cover",
                        }}
                      />
                    ))}
                  </div>
                  <div className="ms-3">
                    <p className="mb-0 fw-bold">Join our team of</p>
                    <p className="mb-0 fs-5 fw-bold" style={{ color: "#009FE1" }}>
                      200+ talented individuals
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container py-5">
          <div className="text-center mb-5">
            <h6 className="text-uppercase fw-bold" style={{ color: "#009FE1", letterSpacing: "2px" }}>
              Our Values
            </h6>
            <h2 className="display-5 fw-bold mb-3">What We Stand For</h2>
            <p className="lead mx-auto" style={{ maxWidth: "700px" }}>
              Our values shape everything we do, from how we develop our products to how we interact with each other.
            </p>
          </div>

          <div className="row g-4">
            {values.map((value, index) => (
              <div key={index} className="col-md-6 col-lg-3">
                <div
                  className="card h-100 border-0 shadow-sm text-center p-4"
                  style={{
                    borderRadius: "16px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 15px 30px rgba(0,0,0,0.1)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = ""
                  }}
                >
                  <div className="card-body">
                    {value.icon}
                    <h4 className="fw-bold mb-3">{value.title}</h4>
                    <p className="text-muted">{value.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-5 mb-5 mb-lg-0">
              <h6 className="text-uppercase fw-bold" style={{ color: "#009FE1", letterSpacing: "2px" }}>
                Benefits
              </h6>
              <h2 className="display-5 fw-bold mb-4">Why Work With Us?</h2>
              <p className="lead mb-4">
                We believe in taking care of our team members. Here are some of the benefits you'll enjoy when you join
                our company.
              </p>
              <img
                src="assets/img/about/about-2.png"
                alt="Team benefits"
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>
            <div className="col-lg-7">
              <div className="row g-4">
                {benefits.map((benefit, index) => (
                  <div key={index} className="col-md-6">
                    <div
                      className="card h-100 border-0 shadow-sm p-4"
                      style={{
                        borderRadius: "16px",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)"
                        e.currentTarget.style.boxShadow = "0 15px 30px rgba(0,0,0,0.1)"
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)"
                        e.currentTarget.style.boxShadow = ""
                      }}
                    >
                      <div className="card-body">
                        <div className="fs-1 mb-3">{benefit.icon}</div>
                        <h4 className="fw-bold mb-2">{benefit.title}</h4>
                        <p className="text-muted mb-0">{benefit.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container py-5">
          <div className="text-center mb-5">
            <h6 className="text-uppercase fw-bold" style={{ color: "#009FE1", letterSpacing: "2px" }}>
              Testimonials
            </h6>
            <h2 className="display-5 fw-bold mb-3">What Our Team Says</h2>
            <p className="lead mx-auto" style={{ maxWidth: "700px" }}>
              Don't just take our word for it. Hear what our team members have to say about working here.
            </p>
          </div>

          <div className="row g-4">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="col-md-4">
                <div
                  className="card h-100 border-0 shadow-sm p-4"
                  style={{
                    borderRadius: "16px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 15px 30px rgba(0,0,0,0.1)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = ""
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-4">
                      <img
                        src={testimonial.image || "/placeholder.svg"}
                        alt={testimonial.name}
                        className="rounded-circle"
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                          border: "3px solid #6d28d9",
                        }}
                      />
                      <div className="ms-3">
                        <h5 className="fw-bold mb-0">{testimonial.name}</h5>
                        <p className="text-muted mb-0">{testimonial.role}</p>
                      </div>
                    </div>
                    <p className="fst-italic mb-0">"{testimonial.quote}"</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Job Openings Section */}
      <section id="job-openings" className="py-5">
        <div className="container py-5">
          <div className="text-center mb-5">
            <h6 className="text-uppercase fw-bold" style={{ color: "#009FE1", letterSpacing: "2px" }}>
              Careers
            </h6>
            <h2 className="display-5 fw-bold mb-3">Open Positions</h2>
            <p className="lead mx-auto" style={{ maxWidth: "700px" }}>
              Join our team and help us build the future. Check out our current openings below.
            </p>
          </div>

          {/* Tabs */}
          <ul className="nav nav-pills py-3 mb-5 justify-content-center">
            <li className="nav-item">
              <button
                className={`nav-link px-4 py-3 ${activeTab === "openings" ? "active" : ""}`}
                style={{
                  borderRadius: "30px",
                  fontWeight: "600",
                  backgroundColor: activeTab === "openings" ? "#009FE1" : "transparent",
                  color: activeTab === "openings" ? "white" : "#333",
                }}
                onClick={() => setActiveTab("openings")}
              >
                <FaBriefcase className="me-2" />
                Job Openings
              </button>
            </li>
            <li className="nav-item ms-3">
              <button
                className={`nav-link px-4 py-3 ${activeTab === "process" ? "active" : ""}`}
                style={{
                  borderRadius: "30px",
                  fontWeight: "600",
                  backgroundColor: activeTab === "process" ? "#009FE1" : "transparent",
                  color: activeTab === "process" ? "white" : "#333",
                }}
                onClick={() => setActiveTab("process")}
              >
                <FaUsers className="me-2" />
                Hiring Process
              </button>
            </li>
          </ul>

          {/* Tab Content */}
          <div className="tab-content">
            {/* Job Openings Tab */}
            <div className={`tab-pane fade ${activeTab === "openings" ? "show active" : ""}`}>
              {/* Search and Filter */}
              <div className="row py-3 mb-5">
                <div className="col-md-4 mb-3 mb-md-0">
                  <div className="position-relative">
                    <input
                      type="text"
                      placeholder="Search for jobs..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="form-control form-control-lg ps-5"
                      style={{
                        borderRadius: "30px",
                        border: "2px solid #e2e8f0",
                        padding: "15px 25px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                        transition: "all 0.3s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#6d28d9"
                        e.target.style.boxShadow = "0 2px 15px rgba(109, 40, 217, 0.1)"
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#e2e8f0"
                        e.target.style.boxShadow = "0 2px 10px rgba(0,0,0,0.05)"
                      }}
                    />
                    <FaSearch
                      style={{
                        position: "absolute",
                        left: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#6d28d9",
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="d-flex py-2 flex-wrap gap-2">
  <button
    onClick={() => setActiveFilter("all")}
    className={`btn ${activeFilter === "all" ? "btn-primary" : "btn-light"}`}
    style={{
      borderRadius: "30px",
      padding: "10px 20px",
      fontWeight: "600",
      backgroundColor: activeFilter === "all" ? "#009FE1" : "#f8f9fa",
      color: activeFilter === "all" ? "white" : "#333",
      border: "none",
      transition: "all 0.3s ease",
    }}
  >
    All
  </button>

  {careerCategories.map((cat) => (
    <button
      key={cat.id}
      onClick={() => setActiveFilter(cat.name)}  // ✅ match job.category_name
      className={`btn ${activeFilter === cat.name ? "btn-primary" : "btn-light"}`}
      style={{
        borderRadius: "30px",
        padding: "10px 20px",
        fontWeight: "600",
        backgroundColor: activeFilter === cat.name ? "#009FE1" : "#f8f9fa",
        color: activeFilter === cat.name ? "white" : "#333",
        border: "none",
        transition: "all 0.3s ease",
      }}
    >
      {cat.name}
    </button>
  ))}
</div>
                </div>
              </div>

              {/* Job Listings */}
              {isLoading ? (
                <div className="text-center py-5">
                  <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ color: "#6d28d9", width: "3rem", height: "3rem" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3 text-muted">Loading job listings...</p>
                </div>
              ) : filteredJobs.length === 0 ? (
                <div className="text-center py-5 bg-light rounded-4">
                  <div className="display-1 mb-3">🔍</div>
                  <h3 className="fw-bold mb-2">No jobs found</h3>
                  <p className="text-muted mx-auto" style={{ maxWidth: "500px" }}>
                    We couldn't find any jobs matching your search criteria. Try adjusting your filters or check back
                    later for new opportunities.
                  </p>
                </div>
              ) : (
                <div className="row g-4">
                  {filteredJobs.map((job) => (
                    <div key={job.id} className="col-md-6 gap-4  py-3 col-lg-4">
                      <JobCard
                      
                        title={job.title}
                        location={job.location}
                        type={job.type}
                        description={job.description}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Hiring Process Tab */}
            <div className={`tab-pane fade ${activeTab === "process" ? "show active" : ""}`}>
              <div className="row">
                <div className="col-lg-6 mb-4 py-5 mb-lg-0">
                  <img
                    src="assets/img/about/about-2.png"
                    alt="Hiring process"
                    className="img-fluid rounded-4 shadow-lg"
                  />
                </div>
                <div className="col-lg-6 py-5">
                  <h3 className="fw-bold mb-4">Our Hiring Process</h3>
                  <p className="mb-4">
                    We've designed our hiring process to be thorough yet efficient, giving both you and us the
                    opportunity to determine if we're a good match.
                  </p>

                  <div className="d-flex mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#009FE1",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      1
                    </div>
                    <div>
                      <h5 className="fw-bold">Application Review</h5>
                      <p className="text-muted">
                        Our team reviews your application and resume to assess your qualifications and experience.
                      </p>
                    </div>
                  </div>

                  <div className="d-flex mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#009FE1",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      2
                    </div>
                    <div>
                      <h5 className="fw-bold">Initial Interview</h5>
                      <p className="text-muted">
                        A 30-45 minute video call with a recruiter to discuss your background and interest in the role.
                      </p>
                    </div>
                  </div>

                  <div className="d-flex mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#009FE1",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      3
                    </div>
                    <div>
                      <h5 className="fw-bold">Technical Assessment</h5>
                      <p className="text-muted">
                        Depending on the role, you may be asked to complete a skills assessment or technical challenge.
                      </p>
                    </div>
                  </div>

                  <div className="d-flex mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#009FE1",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      4
                    </div>
                    <div>
                      <h5 className="fw-bold">Team Interviews</h5>
                      <p className="text-muted">
                        Meet with potential teammates and managers to discuss your experience in more depth.
                      </p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#009FE1",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      5
                    </div>
                    <div>
                      <h5 className="fw-bold">Offer & Onboarding</h5>
                      <p className="text-muted">
                        If there's a mutual fit, we'll extend an offer and begin the onboarding process to set you up
                        for success.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      {/* CTA Section */}
      <section className="py-5 position-relative">
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundColor: "#019EE2",
            clipPath: "polygon(0 15%, 100% 0, 100% 85%, 0 100%)",
          }}
        ></div>

        <div className="container py-5 position-relative">
          <div className="row justify-content-center text-center text-white py-5">
            <div style={{backgroundColor:"#009FE1"}} className="col-lg-8">
              <h2 className="display-4 fw-bold mb-4">Ready to Join Our Team?</h2>
              <p style={{color:"white"}} className="lead mb-5">
                Explore our open positions and find your perfect role. We can't wait to meet you!
              </p>
              <a
                href="#job-openings"
                className="btn btn-light btn-lg px-5 py-3 fw-bold"
                style={{
                  borderRadius: "30px",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "translateY(-5px)"
                  e.target.style.boxShadow = "0 10px 20px rgba(0,0,0,0.15)"
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "translateY(0)"
                  e.target.style.boxShadow = "0 4px 14px rgba(0,0,0,0.1)"
                }}
              >
                View All Positions
              </a>
            </div>
          </div>
        </div>
      </section>

     
    </div>
  )
}

export default CareerPage
